// extracted by mini-css-extract-plugin
export default {"Text":"Responsibility_Text__JF1Ub"};